import { create } from 'zustand'

import { toast } from '@/shared/lib/toast'

import * as salesApi from '../api/sales.api'

const initialState = {
  sales: [],
  meta: null,
  isLoading: true,
  error: null,
}

export const useSalesStore = create((set, get) => ({
  ...initialState,

  clearError: () =>
    set({
      error: null,
    }),

  fetchSales: async (params = {}) => {
    set((state) => ({
      isLoading: state.sales.length === 0,
      error: null,
    }))

    try {
      const result = await salesApi.getSales(params)

      set({
        sales: result.data,
        meta: result.meta,
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to fetch sales'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  createSalesPerson: async (payload) => {
    if (get().isLoading) return null

    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await salesApi.createSales(payload)

      toast.success(result.message || 'Sales person created successfully')

      const salesResult = await salesApi.getSales({
        page: 1,
        limit: 5,
      })

      set({
        sales: salesResult.data,
        meta: salesResult.meta,
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to create sales person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  updateSalesPerson: async (id, payload) => {
    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await salesApi.updateSales(id, payload)

      toast.success(result.message || 'Sales person updated successfully')

      set((state) => ({
        sales: state.sales.map((item) =>
          item._id === id ? result.data : item,
        ),
        isLoading: false,
        error: null,
      }))

      return result
    } catch (error) {
      const message = error.message || 'Failed to update sales person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  deleteSalesPerson: async (id) => {
    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await salesApi.deleteSales(id)

      toast.success(result.message || 'Sales person deleted successfully')

      const salesResult = await salesApi.getSales({
        page: 1,
        limit: 5,
      })

      set({
        sales: salesResult.data,
        meta: salesResult.meta,
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to delete sales person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  assignSalesTarget: async (id, payload) => {
    try {
      const result = await salesApi.assignSalesTarget(id, payload)

      toast.success(result.message || 'Target assigned successfully')

      set((state) => ({
        sales: state.sales.map((item) =>
          item._id === id ? { ...item, ...result.data } : item,
        ),
      }))

      return result
    } catch (error) {
      const message = error.message || 'Failed to assign target'
      toast.error(message)
      throw error
    }
  },
}))
